import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getMain() {
        try
        {            
            const response = await axios.get(`Holidays`,
            {
                headers: {
                    'page_key': pageKeys.holidays
                }
            })          
            return response
        }
        catch (error)
        {
            console.log('Holidays get error')
            throw error
        }
    },
    async get(holidayId) {
        try
        {            
            const response = await axios.get(`Holidays/${holidayId}`,
            {
                headers: {
                    'page_key': pageKeys.holidays
                }
            })          
            return response
        }
        catch (error)
        {
            console.log('Holidays get error')
            throw error
        }
    },
    async getByCompany(fiscalPeriodId) {
        try
        {            
            const response = await axios.get(`Holidays/bycompany/${fiscalPeriodId}`,
            {
                headers: {
                    'page_key': pageKeys.holidays
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('Holidays getByCompany error')
            throw error
        }
    },
    async getThisYear() {
        try
        {            
            const response = await axios.get(`Holidays/thisyear`,
            {
                headers: {
                    'page_key': pageKeys.holidays
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('Holidays getThisYear error')
            throw error
        }
    },
    async getNew(fiscalPeriodId) {
        try
        {            
            const response = await axios.get(`Holidays/new/${fiscalPeriodId}`,
            {
                headers: {
                    'page_key': pageKeys.holidays
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('Holidays getNew error')
            throw error
        }
    },
    async getTypes() {
        try
        {            
            const response = await axios.get(`Holidays/types`,
            {
                headers: {
                    'page_key': pageKeys.holidays
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('Holidays getTypes error')
            throw error
        }
    },
    async getUpComing() {
        try
        {            
            const response = await axios.get(`Holidays/upcoming`)            
            return response
        }
        catch (error)
        {
            console.log('Holidays upcoming error')
            throw error
        }
    },
    async sync(fiscalPeriodId) {
        try
        {            
            const response = await axios.post(`Holidays/sync/${fiscalPeriodId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.holidays
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('Holidays sync error')
            throw error
        }
    },
    async forReview(holidayId) {
        try
        {            
            const response = await axios.post(`Holidays/forReview/${holidayId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.holidays
                }
            })              
            return response
        }
        catch (error)
        {
            console.log('Holidays forReview error')
            throw error
        }
    },
    async approve(holidayId) {
        try
        {            
            const response = await axios.post(`Holidays/approve/${holidayId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.holidays
                }
            })              
            return response
        }
        catch (error)
        {
            console.log('Holidays approve error')
            throw error
        }
    },
    async reject(holidayId) {
        try
        {            
            const response = await axios.post(`Holidays/reject/${holidayId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.holidays
                }
            })              
            return response
        }
        catch (error)
        {
            console.log('Holidays reject error')
            throw error
        }
    },
    async add(data) {
        try
        {            
            const response = await axios.post(`Holidays`, 
            {
                item: data
            },            
            {
                headers: {
                    'page_key': pageKeys.holidays
                }
            })       
            return response
        }
        catch (error)
        {
            console.log('Holidays add error')
            throw error
        }
    },
    async update(data) {
        try
        {            
            const response = await axios.patch(`Holidays`, 
            {
                item: data
            },            
            {
                headers: {
                    'page_key': pageKeys.holidays
                }
            })          
            return response
        }
        catch (error)
        {
            console.log('Holidays update error')
            throw error
        }
    },
    async delete(data) {
        try
        {            
            const response = await axios.post(`Holidays/delete`,
            {
                item: data
            },            
            {
                headers: {
                    'page_key': pageKeys.holidays
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('Holidays upsert error')
            throw error
        }
    },
    async undoDelete(data) {
        try
        {            
            const response = await axios.post(`Holidays/undodelete`, 
            {
                item: data
            },            
            {
                headers: {
                    'page_key': pageKeys.holidays
                }
            })          
            return response
        }
        catch (error)
        {
            console.log('Holidays upsert error')
            throw error
        }
    }
}